<div class="dca-heading flex items-center justify-between px2" aria-label="outline">
  <div class="h2 flex items-center">
    <span>Document outline</span>
  </div>
  <div class="flex items-center">
    <button mat-icon-button matTooltip="Learn more">
      <mat-icon>help_outline</mat-icon>
    </button>
  </div>
</div>
<div class="dca-scrollarea">
  <mat-form-field appearance="fill" class="select-type-field">
    <mat-label>Select Content Type</mat-label>
    <mat-select [(ngModel)]="selectedTypes" #select multiple>
      <div class="select-all">
        <mat-checkbox [checked]="allSelected" (change)="toggleAllSelection()">
        Select All</mat-checkbox>
      </div>
      @for (item of contentTypes; track item) {
        <mat-option [value]="item">{{item}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="info-container">
    <header>
      <h2>Structure your manuscript</h2>
    </header>
    <p>
      The document outline shows all chapters/parts of the document. Always make sure to mark chapter titles as Heading 1.
    </p>
  </div>
  @if (headings$ | async; as headings) {
    <div>
      <mat-list class="disable-select">
        @for (heading of headings | filterByType:selectedTypes; track heading) {
          <mat-list-item class="list-item">
            <div data-id="{{heading.id}}" class="heading level-{{heading.level}} {{heading.type}}" draggable="true"
              matTooltip="drag elements into document" (click)="headingClick(heading)"
              (dragstart)="dragStart($event, heading)" (dragend)="dragEnd($event)">
              <div class="draggable"></div>
              @if (heading.type === 'heading') {
                <span class="heading-level-box">H{{heading.level}}</span>
              }
              @if (heading.type !== 'heading') {
                <span class="heading-level-box uppercase">{{heading.type}}
                {{heading.pos}}</span>
              }
              @if (heading.label && heading.label.length > 0) {
                <span class="heading-text-box"> {{heading.label}}</span>
              }
              @if (!heading.label || heading.label.length === 0) {
                <span class="heading-text-box"> ... </span>
              }
            </div>
            <!-- <mat-icon *ngIf="heading.type === 'figure'">image</mat-icon>
            <mat-icon *ngIf="heading.type === 'code'">code</mat-icon>
            <mat-icon *ngIf="heading.type === 'Equation'">functions</mat-icon>
            <mat-icon *ngIf="heading.type === 'table'">table_chart</mat-icon> -->
          </mat-list-item>
        }
      </mat-list>
    </div>
  }
  <div class="info-container">
    <header>
      <h2>Add more chapters (h1)</h2>
    </header>
    <p>Headings you add to the document will show up here.</p>
    <p><span>To add any other headings h1-h5 you can select any text and click the </span>
    <mat-icon>short_text</mat-icon><span> symbol left to the paragraph.</span>
  </p>
  <header>
    <h2>Cross referencing</h2>
  </header>
  <p>To reference a heading or figure, just drag it into the document.</p>
</div>
</div>